import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from 'react'

import AuthSelectors from 'Stores/Auth/Selectors'
import ChargePointActions from 'Stores/ChargePoint/Actions'
import ChargePointSelectors from 'Stores/ChargePoint/Selectors'
import PropTypes from 'prop-types'
import RequestState from 'Enums/RequestState'
import StationSelectors from 'Stores/Station/Selectors'
import TariffList from '../TariffList/TariffList'
import OperatorUserActions from 'Stores/OperatorUser/Actions'
import OperatorUserSelectors from 'Stores/OperatorUser/Selectors'
import { calculateConnectorsHeight } from 'Utils/ConnectorFunctions'
import { connect } from 'react-redux'

const ChargePointTariff = forwardRef(
  (
    {
      chargePoint,
      fetchStationListRequestState,
      fetchChargePointListRequestState,
      fetchChargePointRequestState,
      isEditing,
      fetchChargePointTariffsList,
      fetchTariffsList,
      chargePointTariffs,
      fetchChargePointTariffsRequestState,
      tariffsList,
      deleteChargePointTariffs,
      addChargePointTariffs,
      maxListHeight,
      removeExtraMargin,
      chargePointUid,
      operator,
    },
    ref,
  ) => {
    const tariffsListRef = useRef()
    useEffect(() => {
      if (
        (chargePoint && !isEditing) ||
        (chargePoint && chargePoint.isActivated === false)
      ) {
        fetchChargePointTariffsList(chargePoint._id)
        fetchTariffsList()
      }
    }, [chargePointUid])

    const handleRefresh = () => {
      fetchChargePointTariffsList(chargePoint._id)
      fetchTariffsList()
    }

    const onSubmit = (addTariffs, deleteTariffs) => {
      if (addTariffs.length > 0 && deleteTariffs.length > 0)
        addChargePointTariffs(chargePoint._id, addTariffs, () => {
          deleteChargePointTariffs(chargePoint._id, deleteTariffs)
        })
      else if (addTariffs.length > 0)
        addChargePointTariffs(chargePoint._id, addTariffs, () => {})
      else if (deleteTariffs.length > 0)
        deleteChargePointTariffs(chargePoint._id, deleteTariffs)
    }

    const handleSubmit = (resetValues) => {
      tariffsListRef?.current?.handleSubmit(resetValues)
    }

    const handleCancel = () => {
      tariffsListRef?.current?.handleCancel()
    }

    const didChange = () => {
      return tariffsListRef?.current?.didChange()
    }

    useImperativeHandle(ref, () => ({
      handleSubmit,
      handleRefresh,
      handleCancel,
      didChange,
    }))

    const isLoading = () => {
      return (
        fetchStationListRequestState === RequestState.LOADING ||
        fetchChargePointListRequestState === RequestState.LOADING ||
        fetchChargePointRequestState === RequestState.LOADING ||
        fetchChargePointTariffsRequestState === RequestState.LOADING
      )
    }

    return (
      <div
        style={{
          display: 'flex',
          height: '100%',
          overflow: isEditing && !isLoading() ? 'unset' : 'hidden',
        }}
      >
        <TariffList
          ref={tariffsListRef}
          displayedList={chargePointTariffs}
          dropdownList={tariffsList}
          isEditing={isEditing}
          isLoading={isLoading()}
          maxListHeight={maxListHeight}
          scrollbarsHeight={
            isLoading()
              ? '68px'
              : calculateConnectorsHeight(
                  chargePoint?.evses?.flatMap(
                    (evse) => evse.connectors || [],
                  ) || [],
                )
          }
          onSubmit={onSubmit}
          removeExtraMargin={removeExtraMargin}
          country={operator.country}
        />
      </div>
    )
  },
)
function mapDispatchToProps(dispatch) {
  return {
    fetchChargePointTariffsList: (chargePointId) =>
      dispatch(ChargePointActions.fetchChargePointTariffsList(chargePointId)),
    fetchTariffsList: () => dispatch(OperatorUserActions.fetchTariffsList()),
    deleteChargePointTariffs: (chargePointId, tariffs) =>
      dispatch(
        ChargePointActions.deleteChargePointTariffs(chargePointId, tariffs),
      ),
    addChargePointTariffs: (chargePointId, tariffs, onResponse) =>
      dispatch(
        ChargePointActions.addChargePointTariffs(
          chargePointId,
          tariffs,
          onResponse,
        ),
      ),
  }
}

const mapStateToProps = (state) => ({
  chargePointTariffs: ChargePointSelectors.getChargePointTariffs(state),
  fetchChargePointTariffsRequestState:
    ChargePointSelectors.getFetchChargePointTariffsRequestState(state),
  tariffsList: OperatorUserSelectors.getTariffsList(state),
  chargePoint: ChargePointSelectors.getSelectedChargePoint(state),
  fetchChargePointRequestState:
    ChargePointSelectors.getFetchChargePointRequestState(state),
  fetchStationListRequestState:
    StationSelectors.getFetchStationListRequestState(state),
  fetchChargePointListRequestState:
    ChargePointSelectors.getFetchChargePointListRequestState(state),
  chargePointUid: ChargePointSelectors.getChargePointUid(state),
  operator: AuthSelectors.getOperator(state),
  addChargePointTariffsRequestState:
    ChargePointSelectors.getAddChargePointTariffsRequestState(state),
  deleteChargePointTariffsRequestState:
    ChargePointSelectors.getDeleteChargePointTariffsRequestState(state),
})

ChargePointTariff.propTypes = {
  fetchStationListRequestState: PropTypes.number,
  fetchChargePointListRequestState: PropTypes.number,
  chargePoint: PropTypes.object,
  fetchChargePointRequestState: PropTypes.number,
  isEditing: PropTypes.bool,
  fetchChargePointTariffsList: PropTypes.func,
  fetchTariffsList: PropTypes.func,
  chargePointTariffs: PropTypes.array,
  fetchChargePointTariffsRequestState: PropTypes.number,
  tariffsList: PropTypes.array,
  deleteChargePointTariffs: PropTypes.func,
  addChargePointTariffs: PropTypes.func,
  tariffsListRef: PropTypes.object,
  maxListHeight: PropTypes.any,
  chargePointUid: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(ChargePointTariff)
